import React, { useEffect, useState } from 'react'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import { useNavigate } from 'react-router-dom'
import '../../css/generals/paper.css'
import styles from '../../css/modals/ModalEstablishment.module.css'
import { getData, putData } from '../../actions/servicesHttp'
import { popupSimple } from '../../components/generals/popups'
import PropTypes from 'prop-types'
import { Dropdown } from 'primereact/dropdown'
import { Message } from 'primereact/message'
import Swal from 'sweetalert2'
import { useTranslation } from 'react-i18next'
import Mapa from '../generals/map'

export default function ModalEstablishment ({ data, onHide, title, show, btnError, btnSuccess, reload }) {
  const { t } = useTranslation('dashboardDevice')
  const navigate = useNavigate()

  const [mode, setMode] = useState('empty')
  const [establishmentUrl] = useState('establishments')
  const [establishments, setEstablishments] = useState()
  const [selectedEstablishment, setSelectedEstablishment] = useState(null)

  function closeModal () {
    onHide()
    reload()
    setSelectedEstablishment(null)
    setMode('empty')
  }

  const getEstablishment = async (url, set, navigate) => {
    const response = await getData(url, undefined, navigate)
    if (response?.status === 200) {
      const establishment = response?.data
      const filteredEstablishments = establishment.filter(item => item.code !== null).map(({ id, code, name }) => ({ id, code, name, label: `${code} - ${name}` }))
      set(filteredEstablishments)
    } else {
      console.log({ error: true, code: response?.code })
      set([])
    }
  }

  useEffect(() => {
    if (data?.establishment !== null) { setMode('unassign') }
    getEstablishment(establishmentUrl, setEstablishments, navigate)
  }, [data])

  const selectedEstablishmentTemplate = (option) => {
    if (option) {
      return (
            <div className="flex align-items-center">
                <div>{option.label}</div>
            </div>
      )
    }

    return <span>{t('modalEstablishment.placeholder')}</span>
  }

  const establishmentOptionTemplate = (option) => {
    return (
        <div className="flex align-items-center">
            <div>{option.label}</div>
        </div>
    )
  }

  const assignEstablishment = async (establishmentId, deviceId) => {
    const json = {
      establishmentId,
      deviceId
    }

    const res = await putData(establishmentUrl, json, navigate)

    if (res?.data?.result) {
      popupSimple('success', t('modalEstablishment.label4'))
    } else {
      popupSimple('error', t('modalEstablishment.label5'))
    }

    closeModal()
  }

  const unassignEstablishment = async (establishmentId, deviceId) => {
    const json = {
      establishmentId,
      deviceId
    }

    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger'
      },
      buttonsStyling: false
    })

    swalWithBootstrapButtons
      .fire({
        title: t('modalEstablishment.message1'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: t('modalEstablishment.button3'),
        cancelButtonText: t('modalEstablishment.button4'),
        reverseButtons: true
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          const res = await putData(establishmentUrl, json, navigate)

          if (res?.data?.result) {
            popupSimple('success', t('modalEstablishment.label9'))
          } else {
            popupSimple('error', t('modalEstablishment.label10'))
          }
        }
        closeModal()
      })
  }

  return (
        <>
            <Modal
                show={show}
                onHide={onHide}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                key={'backgroundChange'}
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">
                        {title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <div className={styles.divLink}>
                            {mode === 'empty' && <a className={styles.link} onClick={() => setMode('assign')}><i className="fa-solid fa-circle-right"></i> {t('modalEstablishment.label1')}</a>}
                            {mode === 'unassign' && <a className={styles.link} onClick={() => unassignEstablishment(null, data?.id)}><i className="fa-solid fa-circle-left"></i> {t('modalEstablishment.label6')}</a>}
                        </div>
                        {mode === 'empty' && <div>
                                <Message
                                    style={{
                                      fontWeight: '600',
                                      padding: '0.4rem',
                                      width: '100%',
                                      marginBottom: '1rem'
                                    }}
                                    severity="info"
                                    text={t('modalEstablishment.label8')}
                                />
                                </div>}
                        {mode === 'assign' && <div>
                            <p className={styles.subtitle}>{t('modalEstablishment.label2')}</p>
                            <Dropdown value={selectedEstablishment} onChange={(e) => setSelectedEstablishment(e.value)} options={establishments} optionLabel="label" placeholder={t('modalEstablishment.placeholder')} filter={true} filterBy="label" valueTemplate={selectedEstablishmentTemplate} itemTemplate={establishmentOptionTemplate} className={`w-full ${styles.dropdown}`} appendTo="self" />
                            {selectedEstablishment !== null &&
                                <Message
                                    style={{
                                      fontWeight: '600',
                                      padding: '0.4rem',
                                      width: '100%'
                                    }}
                                    severity="info"
                                    text={t('modalEstablishment.label3')}
                                />
                            }
                        </div>}
                        {mode === 'unassign' && <div>
                            <p className={styles.subtitle}>{t('modalEstablishment.label11')} <span className={styles.paragraph}>{data?.establishment.name}</span></p>
                            <p className={styles.subtitle}>{t('modalEstablishment.label7')} <span className={styles.paragraph}>{data?.establishment.code}</span></p>
                            <p className={styles.subtitle}>{t('modalEstablishment.label12')} <span className={styles.paragraph}>{data?.establishment.address}</span></p>
                            <p className={styles.subtitle}>{t('modalEstablishment.label13')} <span className={styles.paragraph}>{data?.establishment.district}</span></p>
                            <p className={styles.subtitle}>{t('modalEstablishment.label14')} <span className={styles.paragraph}>{data?.establishment.region}</span></p>
                            <p className={styles.subtitle}>{t('modalEstablishment.label15')} <span className={styles.paragraph}>{data?.establishment.level}</span></p>
                            <p className={styles.subtitle}>{t('modalEstablishment.label16')} <span className={styles.paragraph}>{data?.establishment.type}</span></p>
                            {data?.establishment && <div style={{ height: '26rem' }}>
                                <Mapa info={data?.establishment} type="last"/>
                            </div>}
                        </div>}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={() => closeModal()} variant="danger">
                        {btnError}
                    </Button>
                    {selectedEstablishment !== null && <Button onClick={() => assignEstablishment(selectedEstablishment?.id, data?.id)} variant="primary" id="btnModalSucess" >
                        {btnSuccess}
                    </Button>}
                </Modal.Footer>
            </Modal>
        </>
  )
}

ModalEstablishment.propTypes = {
  onHide: PropTypes.func,
  title: PropTypes.string,
  show: PropTypes.bool,
  btnError: PropTypes.string,
  btnSuccess: PropTypes.string,
  data: PropTypes.object,
  reload: PropTypes.func
}
